import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { MainLayout } from 'layout';
import {
  InfoPage,
  ApplicationWagonPage,
  ApplicationSupplyPage,
  SupplyPrintPage,
  UsersPage,
  ContactsPage,
  ConsigneesPage,
  QueuePage,
  ContractsPage,
} from 'pages';

const ManagerRoutes = () => (
  <MainLayout>
    <Switch>
      <Route exact path="/profile" component={InfoPage} />
      <Route exact path="/profile/:userId" component={InfoPage} />
      <Route exact path="/profile/:userId/contacts" component={ContactsPage} />
      <Route exact path="/profile/:userId/contracts" component={ContractsPage} />
      <Route exact path="/profile/:userId/consignees" component={ConsigneesPage} />
      <Route
        exact
        path="/profile/:userId/applications"
        render={({ match: { params: { userId } } }) => <Redirect to={`/profile/${userId}/applications/supply`} />}
      />
      <Route exact path="/profile/:userId/applications/wagon" component={ApplicationWagonPage} />
      <Route exact path="/profile/:userId/applications/supply" component={ApplicationSupplyPage} />
      <Route exact path="/profile/:userId/applications/supply/archive" component={ApplicationSupplyPage} />
      <Route
        exact
        path="/applications"
        render={() => <Redirect to="/applications/supply" />}
      />
      <Route exact path="/applications/wagon" component={ApplicationWagonPage} />
      <Route exact path="/applications/supply" component={ApplicationSupplyPage} />
      <Route exact path="/applications/supply/archive" component={ApplicationSupplyPage} />
      <Route exact path="/applications/supply/print/:id" component={SupplyPrintPage} />
      <Route exact path="/users" component={UsersPage} />
      <Route exact path="/queue" component={QueuePage} />
      <Redirect to="/queue" />
    </Switch>
  </MainLayout>
);

export default ManagerRoutes;
